import React from 'react';
import { has } from 'lodash';
import InputMask from 'react-input-mask';
import TextField from '@material-ui/core/TextField';

const PhoneNumber = ({
  label,
  value,
  touched,
  handleChange,
  errors,
  name,
  required,
}) => (
  <InputMask
    mask="(999) 999 9999"
    onChange={handleChange}
    value={value}
    maskChar=" "
  >
    {(inputProps) => (
      <TextField
        {...inputProps}
        color="primary"
        error={touched[name] && has(errors, name)}
        fullWidth
        helperText={touched[name] && errors[name]}
        label={label}
        name={name}
        variant="outlined"
        type="tel"
        required={required}
        autoComplete="chrome-off"
      />
    )}
  </InputMask>
);

export default PhoneNumber;
